import {useNavigate} from "react-router-dom";
import {createRouteUrlProvider} from "../di";

export const useNavigateByName = () => {
  let navigate = useNavigate();
  const provider = createRouteUrlProvider();
  return (name: string, params?: Object) => {
    return navigate(provider.getByName(name, params));
  };
};